import React, { useState } from "react";
import useEventStore from "../stores/EventStore";


const DynamicDateInputs = () => {
  const [inputs, setInputs] = useState([""]);
  const { setDateInputs, dateInputs} = useEventStore();

  const handleChange = (index, event) => {
    const newInputs = [...inputs];
    newInputs[index] = event.target.value;
    setInputs(newInputs);
    setDateInputs(newInputs);
  };

  const handleAddInput = () => {
    setInputs([...inputs, ""]);
    setDateInputs([...inputs, ""]);
  };

  const handleRemoveInput = (index) => {
    const newInputs = inputs.filter((_, i) => i !== index);
    setInputs(newInputs);
    setDateInputs(newInputs);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    //console.log("Submitted values:", dateInputs);
  };

  return (
    <form onSubmit={handleSubmit}>
      {inputs.map((value, index) => (
        <div key={index} style={{ marginBottom: "10px" }}>
          <input
            type="datetime-local"
            value={value}
            onChange={(e) => handleChange(index, e)}
            placeholder={`Input ${index + 1}`}
          />
          <button type="button" onClick={() => handleRemoveInput(index)}>
            Entfernen
          </button>
        </div>
      ))}
      <button type="button" onClick={handleAddInput}>
        Feld hinzufügen
      </button>
      {/*<button type="submit">Absenden</button>*/}
    </form>
  );
}

export default DynamicDateInputs;
